// Helpers to export a schedule as Google Calendar link + .ics file.

const toCalDate = (iso) => {
  // "YYYYMMDDTHHMMSSZ" (UTC)
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}` +
    `T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`
  );
};

export const googleCalendarUrl = (schedule) => {
  const start = toCalDate(schedule.scheduled_at);
  const endMs = new Date(schedule.scheduled_at).getTime() + 15 * 60 * 1000;
  const end = toCalDate(new Date(endMs).toISOString());
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: schedule.message,
    dates: `${start}/${end}`,
    details:
      "Scheduled via TimeFlash — your screen will flash this message at the start time.",
  });
  const recur =
    schedule.repeat === "daily"
      ? "RRULE:FREQ=DAILY"
      : schedule.repeat === "weekly"
      ? "RRULE:FREQ=WEEKLY"
      : null;
  if (recur) params.set("recur", recur);
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const buildIcs = (schedule) => {
  const start = toCalDate(schedule.scheduled_at);
  const endMs = new Date(schedule.scheduled_at).getTime() + 15 * 60 * 1000;
  const end = toCalDate(new Date(endMs).toISOString());
  const stamp = toCalDate(new Date().toISOString());
  const uid = `${schedule.id || Math.random().toString(36).slice(2)}@timeflash`;
  const rrule =
    schedule.repeat === "daily"
      ? "RRULE:FREQ=DAILY\r\n"
      : schedule.repeat === "weekly"
      ? "RRULE:FREQ=WEEKLY\r\n"
      : "";
  const escape = (s) => String(s).replace(/[\\;,]/g, (c) => "\\" + c).replace(/\n/g, "\\n");
  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//TimeFlash//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${stamp}`,
    `DTSTART:${start}`,
    `DTEND:${end}`,
    `SUMMARY:${escape(schedule.message)}`,
    "DESCRIPTION:Scheduled via TimeFlash",
    rrule.trim(),
    "END:VEVENT",
    "END:VCALENDAR",
  ]
    .filter(Boolean)
    .join("\r\n");
};

export const downloadIcs = (schedule) => {
  const ics = buildIcs(schedule);
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const safe = (schedule.message || "flash")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .slice(0, 40)
    .replace(/^-|-$/g, "") || "flash";
  a.download = `timeflash-${safe}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
